// MarketsPageSkeleton - Loading state for markets page
import { Box, Skeleton } from '@mui/material';

import { CardSkeleton } from '../../common';

const SKELETON_ITEMS = [1, 2, 3, 4, 5, 6, 7, 8];

const MarketCardSkeletonItem = ({ itemKey }: { itemKey: number }) => <CardSkeleton key={itemKey} />;

export const MarketsSkeleton = () => {
  return (
    <Box sx={{ py: { xs: 1, sm: 2 } }}>
      <Skeleton variant="text" width={200} height={40} sx={{ mb: 2 }} />
      <Box
        sx={{
          display: 'grid',
          gap: { xs: 1.5, sm: 2 },
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
            lg: 'repeat(4, 1fr)',
          },
        }}
      >
        {SKELETON_ITEMS.map((itemKey) => (
          <MarketCardSkeletonItem key={itemKey} itemKey={itemKey} />
        ))}
      </Box>
    </Box>
  );
};

export default MarketsSkeleton;
